import useFastCheckoutNavigation from './useFastCheckoutNavigation';

export default useFastCheckoutNavigation;
